"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEntityProgrammeSetConstructorProps = exports.isProgrammeToItemEdgeType = exports.isEntityProgrammeConstructorProps = exports.isEntityProgramme = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const debug_1 = require("../../../util/lambda/debug");
const EntityProgramme_1 = require("./EntityProgramme");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && true);
const isEntityProgramme = (x) => {
    const c = x;
    const isConstructorProps = (0, exports.isEntityProgrammeConstructorProps)(x);
    const isInstance = c instanceof EntityProgramme_1.EntityProgramme;
    const isEntityProgramme = isConstructorProps && isInstance;
    if (c && !isEntityProgramme) {
        ;
        c?.type === 'EntityProgramme' &&
            console.log(`WARN isEntityProgramme returning false for EntityProgramme ${c.id} with`, { isConstructorProps, isInstance });
    }
    return isEntityProgramme;
};
exports.isEntityProgramme = isEntityProgramme;
const isEntityProgrammeConstructorProps = (x) => {
    const { dayMask, maxNumberOfEntitiesPerTimeslot, name, timeslots } = x ?? {};
    const isEntityProgrammeConstructorProps = (!maxNumberOfEntitiesPerTimeslot || (0, iotv_v3_types_1.isNonNaNNumber)(maxNumberOfEntitiesPerTimeslot) || maxNumberOfEntitiesPerTimeslot === null) &&
        typeof name === 'string' &&
        (dayMask === null || (0, iotv_v3_types_1.isDayMaskDefinition)(dayMask)) &&
        (timeslots === null || (timeslots instanceof Array && (timeslots.length === 0 || timeslots.every(iotv_v3_types_1.isUTCPeriodMins))));
    if (!isEntityProgrammeConstructorProps) {
        ;
        x?.type === 'EntityProgramme' &&
            console.log(`WARN isEntityProgrammeConstructorProps returning false  for EntityProgramme ${x?.id} with`, {
                maxNumberOfEntitiesPerTimeslot,
                name,
                dayMask,
                timeslots,
            });
    }
    return isEntityProgrammeConstructorProps;
};
exports.isEntityProgrammeConstructorProps = isEntityProgrammeConstructorProps;
const isProgrammeToItemEdgeType = (x) => {
    const c = x;
    return !!c && (0, iotv_v3_types_1.isEdge)(c) && !!c.edgeAttributes && c.edgeAttributes.schedules && c.edgeAttributes.schedules.every(iotv_v3_types_1.isUTCDayMaskPeriod);
};
exports.isProgrammeToItemEdgeType = isProgrammeToItemEdgeType;
const isEntityProgrammeSetConstructorProps = (x) => {
    const c = x ?? {};
    const { maxProgrammes, enabled, supportedType, name, appliedTimestampsMs } = c;
    return (
    /*typeof enabled === 'boolean' && typeof supportedType === 'string' &&*/ typeof name === 'string' &&
        (maxProgrammes === null || typeof maxProgrammes === 'number') &&
        (!appliedTimestampsMs || (appliedTimestampsMs instanceof Array && appliedTimestampsMs.every(iotv_v3_types_1.isNonNaNNumber))));
};
exports.isEntityProgrammeSetConstructorProps = isEntityProgrammeSetConstructorProps;
